import type { PortfolioReportingEntryResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const hasReportedValue = (
	reportingData: PortfolioReportingEntryResponseDTO[] | undefined,
) => (reportingData ?? []).some((day) => day.items.length > 0);
